import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dEnum from "../Data.Enum/index.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dOrd$dGeneric from "../Data.Ord.Generic/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUnfoldable1 from "../Data.Unfoldable1/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Unscramble from "../Unscramble/index.js";
const $Locale = tag => ({tag});
const PL = /* #__PURE__ */ $Locale("PL");
const EN = /* #__PURE__ */ $Locale("EN");
const EN_GB = /* #__PURE__ */ $Locale("EN_GB");
const RO = /* #__PURE__ */ $Locale("RO");
const RU = /* #__PURE__ */ $Locale("RU");
const CS = /* #__PURE__ */ $Locale("CS");
const SK = /* #__PURE__ */ $Locale("SK");
const HR = /* #__PURE__ */ $Locale("HR");
const DE = /* #__PURE__ */ $Locale("DE");
const NL = /* #__PURE__ */ $Locale("NL");
const ES = /* #__PURE__ */ $Locale("ES");
const IT = /* #__PURE__ */ $Locale("IT");
const UK = /* #__PURE__ */ $Locale("UK");
const PT_BR = /* #__PURE__ */ $Locale("PT_BR");
const toText = v => {
  if (v.tag === "PL") { return "pl"; }
  if (v.tag === "EN") { return "en"; }
  if (v.tag === "EN_GB") { return "en-GB"; }
  if (v.tag === "RO") { return "ro"; }
  if (v.tag === "RU") { return "ru"; }
  if (v.tag === "CS") { return "cs"; }
  if (v.tag === "SK") { return "sk"; }
  if (v.tag === "HR") { return "hr"; }
  if (v.tag === "DE") { return "de"; }
  if (v.tag === "NL") { return "nl"; }
  if (v.tag === "ES") { return "es"; }
  if (v.tag === "IT") { return "it"; }
  if (v.tag === "UK") { return "uk"; }
  if (v.tag === "PT_BR") { return "pt-BR"; }
  $runtime.fail();
};
const genericLocale = {
  to: x => {
    if (x.tag === "Inl") { return PL; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return EN; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return EN_GB; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return RO; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return RU; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return CS; }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return SK; }
                if (x._1._1._1._1._1._1.tag === "Inr") {
                  if (x._1._1._1._1._1._1._1.tag === "Inl") { return HR; }
                  if (x._1._1._1._1._1._1._1.tag === "Inr") {
                    if (x._1._1._1._1._1._1._1._1.tag === "Inl") { return DE; }
                    if (x._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inl") { return NL; }
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return ES; }
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return IT; }
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return UK; }
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return PT_BR; }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "PL") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "EN") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "EN_GB") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "RO") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "RU") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "CS") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "SK") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
          )
        )
      );
    }
    if (x.tag === "HR") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
            )
          )
        )
      );
    }
    if (x.tag === "DE") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
              )
            )
          )
        )
      );
    }
    if (x.tag === "NL") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ES") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "IT") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "UK") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "PT_BR") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)))
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    $runtime.fail();
  }
};
const showLocale = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "PL"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "EN"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "EN_GB"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "RO"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "RU"});
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "CS"});
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "SK"});
    const $7 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "HR"});
    const $8 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "DE"});
    const $9 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "NL"});
    const $10 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "ES"});
    const $11 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "IT"});
    const $12 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "UK"});
    const $13 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "PT_BR"});
    return x => {
      const $14 = genericLocale.from(x);
      if ($14.tag === "Inl") { return $0["genericShow'"]($14._1); }
      if ($14.tag === "Inr") {
        if ($14._1.tag === "Inl") { return $1["genericShow'"]($14._1._1); }
        if ($14._1.tag === "Inr") {
          if ($14._1._1.tag === "Inl") { return $2["genericShow'"]($14._1._1._1); }
          if ($14._1._1.tag === "Inr") {
            if ($14._1._1._1.tag === "Inl") { return $3["genericShow'"]($14._1._1._1._1); }
            if ($14._1._1._1.tag === "Inr") {
              if ($14._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($14._1._1._1._1._1); }
              if ($14._1._1._1._1.tag === "Inr") {
                if ($14._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($14._1._1._1._1._1._1); }
                if ($14._1._1._1._1._1.tag === "Inr") {
                  if ($14._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($14._1._1._1._1._1._1._1); }
                  if ($14._1._1._1._1._1._1.tag === "Inr") {
                    if ($14._1._1._1._1._1._1._1.tag === "Inl") { return $7["genericShow'"]($14._1._1._1._1._1._1._1._1); }
                    if ($14._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($14._1._1._1._1._1._1._1._1.tag === "Inl") { return $8["genericShow'"]($14._1._1._1._1._1._1._1._1._1); }
                      if ($14._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($14._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9["genericShow'"]($14._1._1._1._1._1._1._1._1._1._1); }
                        if ($14._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($14._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $10["genericShow'"]($14._1._1._1._1._1._1._1._1._1._1._1); }
                          if ($14._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if ($14._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $11["genericShow'"]($14._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if ($14._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if ($14._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $12["genericShow'"]($14._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                              if ($14._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return $13["genericShow'"]($14._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const fromText = v => {
  if (v === "pl") { return Data$dMaybe.$Maybe("Just", PL); }
  if (v === "en") { return Data$dMaybe.$Maybe("Just", EN); }
  if (v === "en-GB") { return Data$dMaybe.$Maybe("Just", EN_GB); }
  if (v === "ro") { return Data$dMaybe.$Maybe("Just", RO); }
  if (v === "ru") { return Data$dMaybe.$Maybe("Just", RU); }
  if (v === "cs") { return Data$dMaybe.$Maybe("Just", CS); }
  if (v === "sk") { return Data$dMaybe.$Maybe("Just", SK); }
  if (v === "hr") { return Data$dMaybe.$Maybe("Just", HR); }
  if (v === "de") { return Data$dMaybe.$Maybe("Just", DE); }
  if (v === "nl") { return Data$dMaybe.$Maybe("Just", NL); }
  if (v === "es") { return Data$dMaybe.$Maybe("Just", ES); }
  if (v === "it") { return Data$dMaybe.$Maybe("Just", IT); }
  if (v === "uk") { return Data$dMaybe.$Maybe("Just", UK); }
  if (v === "pt-BR") { return Data$dMaybe.$Maybe("Just", PT_BR); }
  return Data$dMaybe.Nothing;
};
const unsafeDecodeLocaleFromString = str => {
  const v = fromText(str);
  if (v.tag === "Just") { return v._1; }
  if (v.tag === "Nothing") { return Unscramble.decodingError("Unrecognized locale: " + Data$dShow.showStringImpl(str)); }
  $runtime.fail();
};
const udecodeLocale = {unsafeDecode: x => unsafeDecodeLocaleFromString(Unscramble.decodeString(x))};
const ufromJSONKeyLocale = {fromJSONKey: /* #__PURE__ */ Unscramble.$FromJSONKeyFunction("FromJSONKeyString", unsafeDecodeLocaleFromString)};
const eqLocale = {
  eq: x => y => {
    if (x.tag === "PL") { return y.tag === "PL"; }
    if (x.tag === "EN") { return y.tag === "EN"; }
    if (x.tag === "EN_GB") { return y.tag === "EN_GB"; }
    if (x.tag === "RO") { return y.tag === "RO"; }
    if (x.tag === "RU") { return y.tag === "RU"; }
    if (x.tag === "CS") { return y.tag === "CS"; }
    if (x.tag === "SK") { return y.tag === "SK"; }
    if (x.tag === "HR") { return y.tag === "HR"; }
    if (x.tag === "DE") { return y.tag === "DE"; }
    if (x.tag === "NL") { return y.tag === "NL"; }
    if (x.tag === "ES") { return y.tag === "ES"; }
    if (x.tag === "IT") { return y.tag === "IT"; }
    if (x.tag === "UK") { return y.tag === "UK"; }
    if (x.tag === "PT_BR") { return y.tag === "PT_BR"; }
    return false;
  }
};
const ordLocale = {
  compare: /* #__PURE__ */ (() => {
    const $0 = Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrdering.EQ})(Data$dOrd$dGeneric.genericOrdSum({
      "genericCompare'": v => v1 => Data$dOrdering.EQ
    })(Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrdering.EQ})(Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrdering.EQ})(Data$dOrd$dGeneric.genericOrdSum({
      "genericCompare'": v => v1 => Data$dOrdering.EQ
    })(Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrdering.EQ})(Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrdering.EQ})(Data$dOrd$dGeneric.genericOrdSum({
      "genericCompare'": v => v1 => Data$dOrdering.EQ
    })(Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrdering.EQ})(Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrdering.EQ})(Data$dOrd$dGeneric.genericOrdSum({
      "genericCompare'": v => v1 => Data$dOrdering.EQ
    })(Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrdering.EQ})(Data$dOrd$dGeneric.genericOrdSum({"genericCompare'": v => v1 => Data$dOrdering.EQ})({
      "genericCompare'": v => v1 => Data$dOrdering.EQ
    })))))))))))));
    return x => y => $0["genericCompare'"](genericLocale.from(x))(genericLocale.from(y));
  })(),
  Eq0: () => eqLocale
};
const enumLocale = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericLocale)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)})),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericLocale)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)})),
  Ord0: () => ordLocale
};
const encodeLocale = {
  encode: x => {
    if (x.tag === "PL") { return "pl"; }
    if (x.tag === "EN") { return "en"; }
    if (x.tag === "EN_GB") { return "en-GB"; }
    if (x.tag === "RO") { return "ro"; }
    if (x.tag === "RU") { return "ru"; }
    if (x.tag === "CS") { return "cs"; }
    if (x.tag === "SK") { return "sk"; }
    if (x.tag === "HR") { return "hr"; }
    if (x.tag === "DE") { return "de"; }
    if (x.tag === "NL") { return "nl"; }
    if (x.tag === "ES") { return "es"; }
    if (x.tag === "IT") { return "it"; }
    if (x.tag === "UK") { return "uk"; }
    if (x.tag === "PT_BR") { return "pt-BR"; }
    $runtime.fail();
  }
};
const decodeLocale = {
  decode: f => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("String")(f))(v => {
    const v1 = fromText(v);
    if (v1.tag === "Just") { return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(v1._1); }
    if (v1.tag === "Nothing") {
      return Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError(Data$dNonEmpty.$NonEmpty(
        Foreign.$ForeignError("ForeignError", "Unrecognized locale: " + Data$dShow.showStringImpl(v)),
        Data$dList$dTypes.Nil
      ));
    }
    $runtime.fail();
  })
};
const boundedLocale = /* #__PURE__ */ (() => (
  {
    top: genericLocale.to(Data$dGeneric$dRep.$Sum(
      "Inr",
      Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      )
    )),
    bottom: genericLocale.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordLocale
  }
))();
const boundedEnumLocale = /* #__PURE__ */ (() => (
  {
    cardinality: Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))))))))))))))[
      "genericCardinality'"
    ],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericLocale)(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))))))))))))))),
    fromEnum: (() => {
      const $0 = Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))))))))))))));
      return x => $0["genericFromEnum'"](genericLocale.from(x));
    })(),
    Bounded0: () => boundedLocale,
    Enum1: () => enumLocale
  }
))();
const allLocales = /* #__PURE__ */ (() => Data$dEnum.enumFromTo(enumLocale)(Data$dUnfoldable1.unfoldable1Array)(boundedLocale.bottom)(boundedLocale.top))();
export {
  $Locale,
  CS,
  DE,
  EN,
  EN_GB,
  ES,
  HR,
  IT,
  NL,
  PL,
  PT_BR,
  RO,
  RU,
  SK,
  UK,
  allLocales,
  boundedEnumLocale,
  boundedLocale,
  decodeLocale,
  encodeLocale,
  enumLocale,
  eqLocale,
  fromText,
  genericLocale,
  ordLocale,
  showLocale,
  toText,
  udecodeLocale,
  ufromJSONKeyLocale,
  unsafeDecodeLocaleFromString
};
